import { useQuery } from '../useQuery/useQuery'
import { usePermission } from '../usePermission/usePermission'

import { scope } from '@percent/workplace-giving/common/hoc/withPermissions'
import { getContentTags, ContentTagEntityType } from '@percent/workplace-giving/api/tags/getContentTags/getContentTags'

export const useContentTags = (entityType: ContentTagEntityType, entityId?: string) => {
  const has = usePermission()
  const hasContentTagsScope = has(scope('content_tags'))

  const { data } = useQuery(['getContentTags', { entityType, entityId: entityId! }], getContentTags, {
    enabled: hasContentTagsScope && !!entityId
  })

  return data ?? []
}
